const EmptyAlert = () => {
  return (
    <div className="w-1/3 mx-auto p-3 text-red-500 font-medium text-center bg-red-100 rounded-md">
      <p>Keranjang Kosong</p>
    </div>
  );
};
export default EmptyAlert;
